var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63077 14.5231C7.63077 14.1152 7.96139 13.7846 8.36923 13.7846H14.2769C14.4129 13.7846 14.5231 13.6744 14.5231 13.5385L14.5231 1.72308C14.5231 1.58713 14.4129 1.47692 14.2769 1.47692L8.36923 1.47692C7.96139 1.47692 7.63077 1.1463 7.63077 0.738462C7.63077 0.330622 7.96139 0 8.36923 0H14.2769C15.2286 0 16 0.771448 16 1.72308V13.5385C16 14.4901 15.2286 15.2615 14.2769 15.2615H8.36923C7.96139 15.2615 7.63077 14.9309 7.63077 14.5231Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9253 8.72883C11.9253 9.27262 11.4844 9.71344 10.9407 9.71344H6.15938C6.1368 10.0634 6.10854 10.4131 6.07459 10.7623L6.04539 11.0628C5.9979 11.5515 5.47905 11.8441 5.03635 11.6319C3.23655 10.7694 1.60723 9.58904 0.226739 8.14769L0.197243 8.11689C-0.0657475 7.84231 -0.0657475 7.40929 0.197243 7.1347L0.22674 7.1039C1.60723 5.66256 3.23655 4.48223 5.03635 3.61969C5.47905 3.40752 5.9979 3.70014 6.04539 4.18875L6.07459 4.48925C6.10854 4.83853 6.1368 5.18821 6.15938 5.53817L10.9407 5.53817C11.4844 5.53817 11.9253 5.979 11.9253 6.52278V8.72883Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.e3bdfe468e0209cfc56b71c6f3e3ed7a.svg";
export { ForwardRef as ReactComponent };